import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const useQuery = (param: string) => {
  const query = new URLSearchParams(useLocation().search);
  return query.get(param);
};

export const getNameAvatarImage = (name?: string) => {
  return 'https://ui-avatars.com/api/?name=' + (name ?? '');
};

export interface BeforeUnloadConfig {
  when: boolean;
  message: string;
}

export const useBeforeUnload = ({ when, message }: BeforeUnloadConfig) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    if (when) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when, message]);
};
